export const initShareContent = (): void => {
    const modal = document.getElementById(
        "share-modal",
    ) as HTMLDialogElement | null;
    const closeButtons = document.querySelectorAll<HTMLElement>(
        "[data-close-share-modal]",
    );
    const shareButtons = document.querySelectorAll<HTMLElement>(
        "[data-share-button]",
    );

    if (!modal) return;

    const isMobileDevice = (): boolean => {
        const hasTouchScreen =
            "ontouchstart" in window ||
            navigator.maxTouchPoints > 0 ||
            (navigator as any).msMaxTouchPoints > 0;

        const isMobileUserAgent =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent,
            );

        return hasTouchScreen && isMobileUserAgent;
    };

    const updateShareButtonLabels = (): void => {
        shareButtons.forEach((button) => {
            const labelElement = button.querySelector(
                "[data-share-button-label]",
            );
            if (!labelElement) return;

            const labelType = isMobileDevice()
                ? "data-label-mobile"
                : "data-label-desktop";
            labelElement.textContent = button.getAttribute(labelType) ?? "";
        });
    };

    updateShareButtonLabels();

    const openModal = () => {
        modal.showModal();
        document.body.classList.add("overflow-hidden");
    };

    const closeModal = () => {
        modal.close();
        document.body.classList.remove("overflow-hidden");
    };

    const handleEscapeKey = (event: KeyboardEvent) => {
        if (event.key === "Escape") {
            closeModal();
        }
    };

    const handleModalBackgroundClick = (event: MouseEvent) => {
        const dialogDimensions = modal.getBoundingClientRect();
        const isClickOutsideDialog =
            event.clientX < dialogDimensions.left ||
            event.clientX > dialogDimensions.right ||
            event.clientY < dialogDimensions.top ||
            event.clientY > dialogDimensions.bottom;

        if (isClickOutsideDialog) {
            closeModal();
        }
    };

    const handleMobileShare = async () => {
        if (!navigator.share) {
            openModal();
            return;
        }

        try {
            await navigator.share({
                title: document.title,
                url: window.location.href,
            });
        } catch (error: any) {
            if (error.name === "AbortError") return;

            console.error("Error sharing:", error);
            openModal();
        }
    };

    const handleDesktopShare = () => {
        const linkedInShareUrl = document
            .getElementById("linkedin-share-data")
            ?.getAttribute("data-linkedin-share-url");

        if (linkedInShareUrl) {
            window.open(linkedInShareUrl, "_blank", "width=600,height=400");
        }
    };

    document.addEventListener("keydown", handleEscapeKey);
    modal.addEventListener("click", handleModalBackgroundClick);

    closeButtons.forEach((button) => {
        button.addEventListener("click", closeModal);
    });

    shareButtons.forEach((button) => {
        const container = button.closest("[data-share-container]");
        if (!container) return;

        button.addEventListener("click", async (event) => {
            event.preventDefault();

            if (isMobileDevice()) {
                await handleMobileShare();
            } else {
                handleDesktopShare();
            }
        });
    });

    const platformLinks = modal.querySelectorAll<HTMLAnchorElement>(
        "[data-share-platform]",
    );

    platformLinks.forEach((link) => {
        link.addEventListener("click", () => {
            setTimeout(closeModal, 100);
        });
    });
};
